import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Faq() {
  return (
    <div className="privacy">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title"><span className="base">Frequently Asked Questions</span></h1>
        </div>
        <div className="columns"><div className="column main">
          <h4>How do I place an order?</h4>
          <p>Choose a product, select the quantity, add it to your cart, and follow the checkout steps. Review your contact and delivery details before submitting the order.</p>

          <h4>How can I check an order?</h4>
          <p>Email <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a> with the email address used at checkout and your order reference. Please do not send full payment-card details.</p>

          <h4>Can I change or cancel an order?</h4>
          <p>Contact us as soon as possible. We will try to help before fulfilment begins, but a change or cancellation cannot be guaranteed once an order has been prepared.</p>

          <h4>What if an item arrives damaged or incorrect?</h4>
          <p>Keep the packaging and contact us promptly with your order reference and clear photographs of the item and parcel. We will review the issue and explain the available remedy.</p>

          <h4>How do returns work?</h4>
          <p>Review our <a href="/returns">Returns &amp; Exchanges</a> page before sending anything back. Food and hygiene-sensitive goods may have additional return restrictions.</p>

          <h4>How should I choose food for my pet?</h4>
          <p>Check the product information, ingredient list, life-stage guidance, and feeding directions on the item you receive. Ask a qualified veterinarian about allergies, medical conditions, or significant diet changes.</p>

          <h4>Where can I read your privacy and cookie information?</h4>
          <p>See our <a href="/privacy">Privacy Policy</a> and <a href="/cookies">Cookie Policy</a>. Questions can be sent to our published contact email.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Faq;
